<template>
  <table>
        <thead>
            <tr>
                <th v-for="it of headers" v-html="it"></th>
            </tr>
        </thead>
        <tbody>
            <tr  v-for="it of records">
                <td v-for="sit of it" v-html="sit"></td>
            </tr>
         </tbody>
    </table>
</template>

<script>
import spa_logo from '@/assets/img/kggsee_logo_revs.png';
import pmg_log from '@/assets/img/pmg_logo_rev.png';
export default {
  name: 'navi',
    props:["headers","records"],
  data () {
    return {
    }
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

table
{
    border-collapse: collapse;
    /* margin: 0 auto; */
    text-align: left;
    /* width: 300px;     */
    /* word-break: break-all;  */
    word-wrap:break-word;
    font-size: 15px;
}
table td,th{
    border: 1px solid #cad9ea;
    color: #666;
    height: 25px;
    padding: 5px 10px;
}
table thead th
{
    background:#E0E7D8;
    /* width: 100px; */
    font-weight: bolder;
    color: #000000;

}
table tr:nth-child(odd)
{
    background: #fff;
}
table tr:nth-child(even)
{
    background: #F5FAFA;
}


</style>



// WEBPACK FOOTER //
// src/components/table.vue